import React, { useEffect, useRef, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import dayjs from "dayjs";
import { base_url } from "../../../utils/AxiosConfig";

let LeaveApplicationschema = Yup.object().shape({
  Leave_Category: Yup.string(),
  Notes: Yup.string(),
});

const LeaveApplicationPopup = ({ empPopup, isOpen, onClose }) => {
  console.log("empPopup:", empPopup);
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

  let companyCode = storedUserDataArray?.[0]?.cmpcode || "";

  const [today, setToday] = useState("");

  // const [FromDate, setFromDate] = useState(
  //   new Date().toISOString().split("T")[0],
  // );
  // const [ToDate, setToDate] = useState(new Date().toISOString().split("T")[0]);


  // const todayDate = dayjs().format("dd-mm-yyyy");
  const todayDate = dayjs().format("YYYY-MM-DD");

const [fromDate, setFromDate] = useState(todayDate);
const [toDate, setToDate] = useState(todayDate);

  const [DiffDays, setDiffDays] = useState(1);
  const [LeaveData, setLeaveData] = useState([]);
  const [LeaveHistoryData, setLeaveHistoryData] = useState([]);
  const [OtherLeaveHistoryData, setOtherLeaveHistoryData] = useState([]);
  const [availableDaysCount, setAvailableDaysCount] = useState(0);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      EmpID: empPopup.EmpId ? empPopup.EmpId : "",
      Leave_Category: "",
      // name: empPopup.Name?empPopup.Name :"",
      // ApplicationDAte: today,
      ApplicationDAte: todayDate,
      FromDate: fromDate || "",
      ToDate: toDate || "",
      NoOfDays: DiffDays || "1",
      Notes: "",
      ApprovalSatus: "-",
      ApprovalBy: "HR Manager",
      ApprovalDate: "-",
      RejoinDate: "-",
      RejoinComments: "-",
      Ticket: "-",
      Approvalnote: "-",
      Designation: empPopup.JobTitle ? empPopup.JobTitle : "-",
      CDL_Address: "-",
      CDL_Street: "-",
      CDL_City: "-",
      CDL_State: "-",
      CDL_Zip: "-",
      CDL_Phone: "-",
      CDL_Email: "-",
    },
    validationSchema: LeaveApplicationschema,
    onSubmit: async (values) => {
      try {
        const response = await axios.post(
          `${base_url}/api/PersonalInfoLeaveApplicationReg`,
          [values],
        );

        if (response?.data) {
          toast.success("Leave Application Sent Successfully");
          fetchLeaveHistory();
          OtherLeaveHistory();
          onClose();
        }
      } catch (err) {
        toast.error("Something went wrong");
      }
    },
  });

  useEffect(() => {
    const todayDate = dayjs().format("dd-MMM-yyyy");
    // const today = new Date().toISOString().split("T")[0];
    setToday(todayDate);
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);
      const diff = Math.abs((end - start) / (1000 * 60 * 60 * 24)) + 1;

      setDiffDays(diff);
    }
  }, [fromDate, toDate]);

  const fetchLeaveHistory = async () => {
    const res = await axios.get(
      `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORY/${empPopup.EmpId}/1900-01-01/1900-01-01/-`,
    );
    setLeaveHistoryData(res.data);
  };

  const OtherLeaveHistory = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/PersonalInfoLeaveStatusList/${companyCode}/LEAVEHISTORYOTHER/${
          empPopup?.EmpId ? empPopup?.EmpId : null
        }/${fromDate}/${toDate}/-`,
      );
      if (response?.data) {
        console.log("otherLeaveeHistory", response.data);
        setOtherLeaveHistoryData(response.data);
      } else {
        console.log("error");
      }
    } catch (err) {
      console.error("Error while fetchinh leave history:", err);
    }
  };

  useEffect(() => {
    if (!empPopup?.EmpId) return;

    fetchLeaveHistory();
    OtherLeaveHistory();
  }, [empPopup]);

  useEffect(() => {
    const fetchLeaveCategory = async () => {
      const res = await axios.get(
        `${base_url}/api/CpaysCount/${companyCode}/LEAVECATEGORY/${empPopup?.EmpId}/-`,
      );
      setLeaveData(res.data);
    };

    if (empPopup?.EmpId) fetchLeaveCategory();
  }, [empPopup]);

  const getAvailableDays = async () => {
    if (!formik.values.Leave_Category) return;

    const encoded = encodeURIComponent(formik.values.Leave_Category);

    const res = await axios.get(
      `${base_url}/api/CpaysCount/${companyCode}/AVAIL_LEAVES/${empPopup?.EmpId}/${encoded}`,
    );

    setAvailableDaysCount(res.data?.[0]?.Balance || 0);
  };

  useEffect(() => {
    getAvailableDays();
  }, [formik.values.Leave_Category]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* modal */}
      <div className="relative bg-white rounded-xl shadow-2xl w-[95%] max-w-6xl max-h-[90vh] overflow-hidden">
        {/* header */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-blue-600 text-white">
          <h2 className="text-lg font-semibold">Leave Application</h2>

          <button
            onClick={onClose}
            className="text-2xl font-bold hover:text-gray-200"
          >
            ×
          </button>
        </div>

        {/* body */}
        <div className="p-6 overflow-y-auto max-h-[80vh]">
          <form onSubmit={formik.handleSubmit}>
            {/* form grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <label className="text-sm font-medium">Request Date</label>
                <input
                  // type="text"
                  type="date"
                  // value={today}
                  value={todayDate}
                  disabled
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-100"
                />
              </div>

              <div>
                <label className="text-sm font-medium">Emp ID</label>
                <input
                  type="text"
                  value={empPopup?.EmpId}
                  disabled
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-100"
                />
              </div>

              <div>
                <label className="text-sm font-medium">Emp Name</label>
                <input
                  type="text"
                  value={empPopup?.Name}
                  disabled
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-100"
                />
              </div>

              <div>
                <label className="text-sm font-medium">Designation</label>
                <input
                  type="text"
                  value={empPopup?.JobTitle}
                  disabled
                  className="w-full border rounded-lg px-3 py-2 text-sm bg-gray-100"
                />
              </div>

              <div>
                <label className="text-sm font-medium">Leave From</label>
                <input
                  type="date"
                  onChange={(e) => setFromDate(e.target.value)}
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                  value={fromDate}
                />
              </div>

              <div className="">
                <label className="text-sm font-medium">Leave To</label>
                <div className="flex gap-2">
                  <input
                    type="date"
                    onChange={(e) => setToDate(e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm"
                    value={toDate}
                  />
                  {/* </div> */}
                  {/* <div className="flex items-end"> */}
                  <p className="text-red-500 font-semibold text-[0.6rem]">
                    Days : {DiffDays}
                  </p>
                </div>
              </div>

              <div>
                <label className="text-sm font-medium">Leave Category</label>
                <select
                  {...formik.getFieldProps("Leave_Category")}
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                >
                  <option>Select Category</option>

                  {LeaveData?.map((d, i) => (
                    <option key={i} value={d?.leavecateGory}>
                      {d?.leavecateGory}
                    </option>
                  ))}
                </select>
              </div>

              <div className="flex items-end">
                <p className="text-blue-600 font-semibold">
                  Available Days : {availableDaysCount}
                </p>
              </div>

              <div className="col-span-2">
                <label className="text-sm font-medium">Leave Reason</label>

                <input
                  {...formik.getFieldProps("Notes")}
                  className="w-full border rounded-lg px-3 py-2 text-sm"
                />
              </div>
            </div>

            {/* submit */}
            <div className="flex justify-center mt-6">
              <button
                type="submit"
                className="flex items-center gap-2 bg-green-600 text-white px-5 py-2 rounded-lg hover:bg-green-700"
              >
                <IoIosAddCircleOutline size={20} />
                Apply Leave
              </button>
            </div>
          </form>

          {/* Leave History */}
          <div className="mt-8">
            <h3 className="font-semibold mb-3">Leave History</h3>

            <div className="overflow-auto max-h-60 border rounded-lg scrollbar-none">
              <table className="min-w-full text-sm">
                <thead className="bg-[#2663EB] sticky top-0 text-white">
                  <tr>
                    <th className="font-thin pl-2">Sl No</th>
                    <th className="font-thin">Type</th>
                    <th className="font-thin">From</th>
                    <th className="font-thin">To</th>
                    <th className="font-thin">Status</th>
                    <th className="font-thin">Notes</th>
                  </tr>
                </thead>

                <tbody>
                  {LeaveHistoryData?.map((d, i) => (
                    <tr key={i} className="border-t">
                      <td className="p-2">{i + 1}</td>
                      <td>{d?.Leave_Type}</td>
                      <td>{dayjs(d?.FROM_DT).format("DD-MMM-YYYY ")}</td>
                      <td>{dayjs(d?.TO_DATE).format("DD-MMM-YYYY ")}</td>
                      <td>{d?.Status}</td>
                      <td>{d?.NOTES}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Other Leave History */}
          <div className="mt-8">
            <h3 className="font-semibold mb-1">Other Leave History</h3>
            <h5 className="font-thin text-xs mb-2">
              {" "}
              Other employees on leave approved on the requested period
            </h5>

            <div className="overflow-auto max-h-60 border rounded-lg scrollbar-none">
              <table className="min-w-full text-sm">
                <thead className="bg-[#2663EB] sticky top-0 text-white">
                  <tr>
                    <th className="font-thin pl-2">Sl No</th>
                    <th className="font-thin">EmpID</th>
                    <th className="font-thin">Name</th>
                    <th className="font-thin">Job Title</th>
                    <th className="font-thin">Leave Name</th>
                    <th className="font-thin">Application Date</th>
                    <th className="font-thin">Leave From</th>
                    <th className="font-thin">Leave To</th>
                    <th className="font-thin">Total Days</th>
                    <th className="font-thin">Notes</th>
                    <th className="font-thin">ApprovalStatus</th>
                  </tr>
                </thead>

                <tbody>
                  {OtherLeaveHistoryData?.map((d, i) => (
                    <tr key={i} className="border-t">
                      <td>{i + 1}</td>
                      <td>{d?.EmpId}</td>
                      <td>{d?.Name}</td>
                      <td>{d?.JobTitle}</td>
                      <td>{d?.Leave_Name}</td>
                      <td>{dayjs(d?.ApplicationDate).format("DD-MMM-YYYY ")}</td>
                      <td>{dayjs(d?.Leave_From).format("DD-MMM-YYYY ")}</td>
                      <td>{dayjs(d?.Leave_To).format("DD-MMM-YYYY ")}</td>
                      <td>{d?.Total_Days}</td>
                      <td>{d?.Notes}</td>
                      <td>{d?.ApprovalStatus}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveApplicationPopup;
